import React from 'react'
import Icon from '../../misc/Icons'
import EmailVerificationEnvelopeIllustration from './EmailVerificationEnvelopeIllustration'
import EmailVerificationButtonLabel from './EmailVerificationButtonLabel'

// Combined screen for when both affirmPrimary and affirmBackup are due at
// once — one "yes, they are" affirms both addresses in a single action
// instead of two sequential lightweight asks.
const EmailVerificationAffirmBothOffer = (props) => {
  const {
    primaryEmail, backupEmail, onAffirm, onRemindLater,
    onDifferentPrimaryEmail, onDifferentBackupEmail,
    onConfirmedAction, confirmedActionLabel,
    confirmLoading, confirmedMessage, errorMessage,
  } = props

  return (
    <div className='emailVerificationFlow-primaryOffer'>
      <EmailVerificationEnvelopeIllustration checkColor={confirmedMessage ? '#30C99C' : undefined} />
      <div className='emailVerificationFlow-title'>Are these still your email addresses?</div>
      <div className='emailVerificationFlow-emailBox'>
        <div className='emailVerificationFlow-emailBox-label'>Account email address</div>
        <div className='emailVerificationFlow-emailBox-row'>
          <div className='emailVerificationFlow-emailDisplay'>{primaryEmail}</div>
          {!confirmedMessage && (
            <button
              type='button'
              className='emailVerificationFlow-emailBox-editBtn'
              onClick={onDifferentPrimaryEmail}
              aria-label='Update account email address'
            >
              <Icon name='pencil' />
            </button>
          )}
        </div>
        <div className='emailVerificationFlow-emailBox-label emailVerificationFlow-emailBox-label--spaced'>
          Backup email address
        </div>
        <div className='emailVerificationFlow-emailBox-row'>
          <div className='emailVerificationFlow-emailDisplay'>{backupEmail}</div>
          {!confirmedMessage && (
            <button
              type='button'
              className='emailVerificationFlow-emailBox-editBtn'
              onClick={onDifferentBackupEmail}
              aria-label='Update backup'
            >
              <Icon name='pencil' />
            </button>
          )}
        </div>
      </div>
      {errorMessage && (
        <div className='emailVerificationFlow-error'>{errorMessage}</div>
      )}
      {confirmedMessage && (
        <div className='emailVerificationFlow-codeEntry-verifiedMessage'>{confirmedMessage}</div>
      )}
      <button
        type='button'
        className={`btn btn--blue btn--large${confirmLoading ? ' btn--disabled' : ''}`}
        onClick={confirmedMessage ? onConfirmedAction : onAffirm}
        disabled={confirmLoading}
      >
        <EmailVerificationButtonLabel
          label={confirmedMessage ? confirmedActionLabel : 'Yes, they are'}
          loading={confirmLoading}
        />
      </button>
      {!confirmedMessage && (
        <div className='emailVerificationFlow-primaryOffer-links'>
          <button
            type='button'
            className='emailVerificationFlow-linkBtn'
            onClick={onRemindLater}
          >
            Remind me later
          </button>
        </div>
      )}
    </div>
  )
}

export default EmailVerificationAffirmBothOffer
